import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750991323143/1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750991322913/1-h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750991323501/2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750991323322/2-h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750991323969/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750991323796/3-h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750991324470/4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750991324231/4-h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750991324990/5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750991324729/5-h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750991325631/6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750991325301/6-h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750991326141/7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750991325942/7-h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750991326714/8.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750991326402/8-h5.jpg',
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <div className="list">
                {list.map((i, idx) => (
                    <div className="item" key={idx}>
                        <EcoImg pc={i.pc} pad={i.pc} h5={i.h5} />
                        <div className="info">
                            {t(`B_text_label${idx + 1}`) && <div className="info-label">{t(`B_text_label${idx + 1}`)}</div>}
                            {t(`B_text_title${idx + 1}`) && <div className="info-title">{t(`B_text_title${idx + 1}`)}</div>}
                            {t(`B_text_desc${idx + 1}`) && <div className="info-desc">{t(`B_text_desc${idx + 1}`)}</div>}
                        </div>
                    </div>
                ))}
            </div>
            <EfSpec className="spec-x" />
        </div>
    );
}
